import { Controller } from '@hotwired/stimulus'

// The Crisp widget is injected asynchronously by GTM, so we have to poll until it is available.
export default class CrispChatController extends Controller {
  static POLLING_INTERVAL_IN_MS = 500;
  static MAX_POLLING_ATTEMPTS = 20;

  static values = {
    unavailableMessage: String,
  };

  connect() {
    const url = new URL(window.location.href);
    if (url.searchParams.get('open_chat') !== '1') { return; }

    // Strip the param so the chat does not reopen on refresh or back navigation.
    url.searchParams.delete('open_chat');
    history.replaceState(history.state, '', url.toString());

    this.pollingAttempts = 0;
    this.pollingIntervalId = setInterval(
      () => { this.openChatWhenAvailable(); },
      CrispChatController.POLLING_INTERVAL_IN_MS
    );
  }

  disconnect() {
    this.stopPolling();
  }

  openChatWhenAvailable() {
    this.pollingAttempts += 1;
    if (window.$crisp) {
      window.$crisp.push(['do', 'chat:open']);
      this.stopPolling();
    } else if (this.pollingAttempts >= CrispChatController.MAX_POLLING_ATTEMPTS) {
      this.stopPolling();
      toastr.error(this.unavailableMessageValue);
    }
  }

  stopPolling() {
    if (this.pollingIntervalId) {
      clearInterval(this.pollingIntervalId);
      this.pollingIntervalId = null;
    }
  }
}
